import { render, staticRenderFns } from "./JobStatusHistory.vue?vue&type=template&id=146cde1c"
import script from "./JobStatusHistory.vue?vue&type=script&lang=js"
export * from "./JobStatusHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports